import { z } from 'zod';

export const CareDocumentCheckableItemSchema = z.object({
  checked: z.boolean().optional(),
  value: z.string().nullish(),
});

export type CareDocumentCheckableItem = z.infer<
  typeof CareDocumentCheckableItemSchema
>;
